import { createTheme } from '@mui/material/styles';

/**
 * Builders Pulse theme — clean white + deep charcoal dark, amber accent.
 * Chart colors validated for contrast/CVD per mode (see chartColors).
 */
const FONTS = `'Inter','Noto Sans Telugu','Noto Sans Devanagari',-apple-system,'Segoe UI',Roboto,sans-serif`;

export const chartColors = {
  light: { spend: '#B0730D', trend: '#00879B' },
  dark: { spend: '#D68F2C', trend: '#2AA5B4' },
};

export const getTheme = (mode) =>
  createTheme({
    palette:
      mode === 'dark'
        ? {
            mode: 'dark',
            primary: { main: '#F0A93B', contrastText: '#1a1205' },
            secondary: { main: '#2AA5B4' },
            background: { default: '#0f1214', paper: '#171c20' },
            divider: 'rgba(255,255,255,0.08)',
            text: { primary: '#f2f4f5', secondary: '#9aa4ab' },
            success: { main: '#4caf7d' },
            error: { main: '#ef6461' },
          }
        : {
            mode: 'light',
            primary: { main: '#9a6407', contrastText: '#ffffff' },
            secondary: { main: '#00879B' },
            background: { default: '#f5f6f7', paper: '#ffffff' },
            divider: 'rgba(0,0,0,0.08)',
            text: { primary: '#1a1e22', secondary: '#5c666d' },
            success: { main: '#1e7d4f' },
            error: { main: '#c62f2c' },
          },
    typography: {
      fontFamily: FONTS,
      h4: { fontWeight: 800, letterSpacing: '-0.02em' },
      h5: { fontWeight: 700, letterSpacing: '-0.01em' },
      h6: { fontWeight: 700 },
      subtitle1: { fontWeight: 600 },
      subtitle2: { fontWeight: 600 },
      button: { textTransform: 'none', fontWeight: 600 },
    },
    shape: { borderRadius: 14 },
    components: {
      MuiCssBaseline: {
        styleOverrides: (t) => ({
          body: { backgroundColor: t.palette.background.default },
        }),
      },
      MuiCard: {
        defaultProps: { elevation: 0 },
        styleOverrides: {
          root: ({ theme }) => ({
            border: `1px solid ${theme.palette.divider}`,
            backgroundImage: 'none',
          }),
        },
      },
      MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: 12, paddingTop: 10, paddingBottom: 10 },
          sizeLarge: { paddingTop: 14, paddingBottom: 14, fontSize: '1.05rem' },
        },
      },
      MuiTextField: { defaultProps: { fullWidth: true } },
      MuiDialog: {
        styleOverrides: { paper: { borderRadius: 20, backgroundImage: 'none' } },
      },
      MuiChip: { styleOverrides: { root: { fontWeight: 600 } } },
      MuiBottomNavigation: {
        styleOverrides: {
          root: ({ theme }) => ({ borderTop: `1px solid ${theme.palette.divider}` }),
        },
      },
    },
  });
